module.exports = __webpack_public_path__ + "static/media/Carp.metal.bb111fd4.png";